export default "__VITE_ASSET__fee54d17__"